module.exports = __webpack_public_path__ + "img/result-detail-output-icon01.117f7d6f.svg";